function showDocumentType(type) {
  switch (type) {
    case "purchase":
      return "خرید";
    case "installment_purchase":
      return "خرید اقساطی";
    case "sale":
      return "فروش";
    case "installment_sale":
      return "فروش اقساطی";
    default:
      return "-";
  }
}

export default showDocumentType;
